import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AdministrationComponent } from './administration/administration.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DocumentsComponent } from './documents/documents.component';
import { EmployeeOverviewComponent } from './employee-overview/employee-overview.component';
import { ErrorComponent } from './common/error/error.component';
import { MessagesComponent } from './messages/messages.component';
import { NewRegistrationComponent } from './home/new-registration/new-registration.component';
import { RegistrationComponent } from './registration/registration.component';
import { SuccessfulRegistrationComponent } from './successful-registration/successful-registration.component';
import { GuestComponent } from './guest/guest.component';
import { RedirectComponent } from './redirect/redirect.component';
import { LicenseComponent } from './license/license.component';
import { LoginGuardService } from './services/login-guard.service';
import { PanelComponent } from './panel/panel.component';
import { JurisdictionComponent } from './jurisdiction/jurisdiction.component';

import { PersonalDataComponent } from './jurisdiction/personal-data/personal-data.component';

import { TechnicalDataComponent } from './jurisdiction/technical-data/technical-data.component';

import { DocumentsSubmissionComponent } from './+shared/components/documents-submission/documents-submission.component';
import { JurisdictionOverviewComponent } from './jurisdiction-overview/jurisdiction-overview.component';
import { TechnicianDataComponent } from './jurisdiction/technician-data/technician-data.component';
import { ProcessDetailsComponent } from './jurisdiction/process-details/process-details.component';
import { SubmittedComponent } from './submitted/submitted.component';
import { ImpressumComponent } from './impressum/impressum.component';
import { NewAdditionsComponent } from './new-additions/new-additions.component';
import { DownloadCenterComponent } from './download-center/download-center.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { SiteElectricityInstallationTechnicalDataComponent } from './jurisdiction/siteelectricity-installation-technical-data/siteelectricity-installation-technical-data.component';
import { FacilitiesDataComponent } from './jurisdiction/facilities-data/facilities-data.component';
import { ConcessionBasicProfileComponent } from './concession-registration/concession-basic-profile/concession-basic-profile.component';
import { PendingChangesGuard } from './+shared/guards/pending-changes-guard.servie';
import { DataGopComponent } from './data-gop/data-gop.component';
import { InviteRegistrationComponent } from './invite-registration/invite-registration.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { PageNotFoundComponent } from './+error-handling/page-not-found/page-not-found.component';

export const ROUTES: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
  },
  {
    path: 'impressum',
    component: ImpressumComponent,
  },
  {
    path: 'gridcomp',
    loadChildren: () => import('./+grid-compatibility/grid-compatibility.module').then(m => m.GridCompatibilityModule),
    canActivate: [LoginGuardService],
    data: {
      module: 'gridcomp',
    },
  },
  {
    path: 'regep',
    loadChildren: () => import('./+regep/regep.module').then(m => m.RegepModule),
    canActivate: [LoginGuardService],
    data: {
      module: 'regep',
    },
  },
  {
    path: 'drr-ccd-devices',
    loadChildren: () => import('./+drr-ccd-devices/drr-ccd-devices.module').then(m => m.DrrCcdDevicesModule),
    canActivate: [LoginGuardService],
    data: {
      module: 'drr-ccd-devices',
    },
  },
  {
    path: 'administration',
    component: AdministrationComponent,
    canActivate: [LoginGuardService],
  },
  {
    path: 'redirect',
    component: RedirectComponent,
    canActivate: [LoginGuardService],
  },
  {
    path: 'license',
    component: LicenseComponent,
    canActivate: [LoginGuardService],
  },
  {
    path: 'register',
    component: RegistrationComponent,
    canActivate: [LoginGuardService],
  },
  {
    path: 'register-gop',
    component: ConcessionBasicProfileComponent,
    canActivate: [LoginGuardService],
  },
  {
    path: 'guest',
    component: GuestComponent,
    canActivate: [LoginGuardService],
  },
  {
    path: 'employee-overview',
    component: EmployeeOverviewComponent,
    canActivate: [LoginGuardService],
  },
  {
    path: 'new-registration',
    component: NewRegistrationComponent,
    canActivate: [LoginGuardService],
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent,
    canActivate: [LoginGuardService],
  },
  {
    path: 'messages',
    component: MessagesComponent,
    canActivate: [LoginGuardService],
  },
  {
    path: 'employee-overview/messages/:technicianId',
    component: MessagesComponent,
    canActivate: [LoginGuardService],
  },
  {
    path: 'jurisdiction-overview/messages/:technicianId',
    component: MessagesComponent,
    canActivate: [LoginGuardService],
  },
  {
    path: 'documents',
    component: DocumentsComponent,
    canActivate: [LoginGuardService],
  },
  {
    path: 'data',
    component: RegistrationComponent,
    canActivate: [LoginGuardService],
    data: { isRenewConcession: true },
  },
  {
    path: 'mydata',
    component: DataGopComponent,
    canActivate: [LoginGuardService],
  },
  {
    path: 'successful-registration',
    component: SuccessfulRegistrationComponent,
  },
  {
    path: 'jurisdiction',
    component: JurisdictionComponent,
    canActivate: [LoginGuardService],
  },
  {
    path: 'panel',
    component: PanelComponent,
    canActivate: [LoginGuardService],
  },
  {
    path: 'personal-data',
    component: PersonalDataComponent,
    canActivate: [LoginGuardService],
    canDeactivate: [PendingChangesGuard],
  },
  {
    path: 'facilities-data',
    component: FacilitiesDataComponent,
    canActivate: [LoginGuardService],
    canDeactivate: [PendingChangesGuard],
  },
  {
    path: 'technical-data',
    component: TechnicalDataComponent,
    canActivate: [LoginGuardService],
    canDeactivate: [PendingChangesGuard],
  },
  {
    path: 'site-electricity-technical-data',
    component: SiteElectricityInstallationTechnicalDataComponent,
    canActivate: [LoginGuardService],
  },
  {
    path: 'documents-submission',
    component: DocumentsSubmissionComponent,
    canActivate: [LoginGuardService],
    canDeactivate: [PendingChangesGuard],
  },
  {
    path: 'jurisdiction-overview',
    children: [
      {
        path: 'archive',
        component: JurisdictionOverviewComponent,
      },
    ],
    component: JurisdictionOverviewComponent,
    canActivate: [LoginGuardService],
  },
  {
    path: 'process-details',
    component: ProcessDetailsComponent,
    canActivate: [LoginGuardService],
  },
  {
    path: 'technician-form',
    component: TechnicianDataComponent,
    canActivate: [LoginGuardService],
    canDeactivate: [PendingChangesGuard],
  },
  {
    path: 'submitted',
    component: SubmittedComponent,
    canActivate: [LoginGuardService],
  },
  {
    path: 'new-additions',
    component: NewAdditionsComponent,
    canActivate: [LoginGuardService],
  },
  {
    path: 'download-center',
    component: DownloadCenterComponent,
    canActivate: [LoginGuardService],
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
  },
  {
    path: 'invite-register/:token',
    component: InviteRegistrationComponent,
  },
  {
    path: 'reset-password/:token',
    component: ResetPasswordComponent,
  },
  {
    path: 'error',
    loadChildren: './+error-handling/error-handling.module#ErrorHandlingModule',
  },
  {
    path: 'error',
    component: ErrorComponent,
    canActivate: [LoginGuardService],
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(ROUTES)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
